import { useEffect, useState } from "react";
import menuOnClick from "../menuOnClick";

const RightQuick = () => {
  const [visiable, setVisiable] = useState(false);

  useEffect(() => {
    var vh = window.innerHeight;
    window.addEventListener("scroll", () => {
      if (window.pageYOffset > vh) setVisiable(true);
      else setVisiable(false);
    });
    return () => {
      window.removeEventListener("scroll", () => {
        if (window.pageYOffset > vh) setVisiable(true);
        else setVisiable(false);
      });
    };
  }, []);

  return (
    <>
      {/* {visiable && ( */}
      <div
        className={
          visiable
            ? "hidden lg:block fixed right-6 3xl:right-[calc((100%-var(--container))/2)] top-1/2 -translate-y-48 w-fit h-fit z-10 opacity-100 transition-all duration-500"
            : "hidden lg:block opacity-0"
        }
      >
        <div className=" relative w-full h-full bg-primary text-white border-light rounded-lg grid grid-rows-5 px-3">
          <button
            onClick={() => menuOnClick("#about")}
            type="button"
            className="grid items-center border-b py-4"
          >
            <p className="text-sm">회사소개</p>
          </button>
          <button
            onClick={() => menuOnClick("#service")}
            type="button"
            className="grid items-center border-b py-4"
          >
            <p className="text-sm">서비스</p>
          </button>
          <button
            onClick={() => menuOnClick("#equip")}
            type="button"
            className="grid items-center border-b py-4"
          >
            <p className="text-sm">최신장비</p>
          </button>
          <button
            onClick={() => menuOnClick("#blog")}
            type="button"
            className="grid items-center border-b  py-4"
          >
            <p className="text-sm">고객후기</p>
          </button>
          <button
            onClick={() => menuOnClick("#banner")}
            type="button"
            className="grid items-center py-4"
          >
            <img
              src="/images/iconUp.png"
              alt="맨 위로 이동"
              width={84}
              height={50}
              className="!relative w-full h-auto max-w-10 mx-auto"
            />
          </button>
        </div>
        <div className="grid grid-rows-2 gap-3 mt-3">
          <button
            type="button"
            onClick={() => window.open("https://blog.naver.com/easthans")}
            className=" relative w-fit h-fit max-w-[4.5rem] transition-transform duration-200 hover:shadow-md rounded-full"
          >
            <img
              src="/images/iconNaver.png"
              alt="장인배관 네이버 블로그 바로가기"
              className="!relative w-full h-full object-contain"
            />
          </button>
          <button
            type="button"
            onClick={() => window.open("https://open.kakao.com/o/sD0a2Mmi")}
            className=" relative w-fit h-fit max-w-[4.5rem] transition-transform duration-200 hover:shadow-md rounded-full"
          >
            <img
              src="/images/iconKakao.png"
              alt="장인배관 카카오톡 상담하기"
              className="!relative w-full h-full object-contain"
            />
          </button>
        </div>
      </div>
      {/* )} */}
    </>
  );
};

export default RightQuick;
